import { Component, OnInit, Output, Input, EventEmitter, OnDestroy, signal, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { OrganisationService } from '../../services/organisation.service';
import { AuthService } from '../../auth/auth.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { SortPipe } from '../../shared/pipes/sort.pipe';

@Component({
  selector: 'app-modal-select-organisation',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, NgxPaginationModule, SortPipe],
  templateUrl: './modal-select-organisation.component.html',
  styleUrl: './modal-select-organisation.component.css'
})
export class ModalSelectOrganisationComponent implements OnInit, OnDestroy {

  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Input() orgList: any[] = [];
  @Input() titleKey = 'CHOOSE_ORGANISATION';

  // Services using inject()
  private authService = inject(AuthService);
  private organisationService = inject(OrganisationService);

  // Signals
  selectedOrganisation = signal<any>(null);
  organisations = signal<any[]>([]);
  userSearch = signal({
    all: "",
    name: "",
  });

  // Legacy properties
  itemsPerPage = signal<number>(10);
  pageNumber = signal<number>(1);
  path: any;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    // Always set organisations to an array, even if orgList is undefined/null
    const orgList = Array.isArray(this.orgList) ? this.orgList : [];
    this.organisations.set(orgList);
  }

  ngOnDestroy(): void {
    if (this.selectedOrganisation()) {
      this.organisationService.organisationChanged.next(this.selectedOrganisation());
    }
  }

  add() {
    localStorage.setItem("newItem", "new");
    this.activeModal.close(ModalSelectOrganisationComponent);
  }

  select(organisation: any) {
    this.selectedOrganisation.set(organisation);
    this.organisationService.getOrganisation(organisation.id);
    this.organisationService.getOrganisationOrgDataListener().pipe(take(1)).subscribe({
      next: (orgData: any) => {
        localStorage.setItem('selectedOrganisation', JSON.stringify(orgData));
        localStorage.setItem('rootOrganisation', JSON.stringify(orgData));
        localStorage.setItem('selectedDepartment', JSON.stringify(orgData));
        localStorage.removeItem("allDepartments");
        this.passEntry.emit(orgData);
        this.activeModal.close(ModalSelectOrganisationComponent);
      },
      error: (error: any) => {
        this.passEntry.emit(organisation);
        this.activeModal.close(ModalSelectOrganisationComponent);
      }
    });
  }

  logout() {
    this.authService.logout();
  }

  updateUserSearch(value: string) {
    this.userSearch.update(current => ({ ...current, name: value }));
  }

  // Computed properties for filtering
  filteredOrganisations = computed(() => {
    const searchTerm = this.userSearch().name.toLowerCase();
    if (!searchTerm) return this.organisations();

    return this.organisations().filter(org => {
      const name = (org?.name ?? '').toString().toLowerCase();
      const alternativeName = (org?.alternative_name ?? '').toString().toLowerCase();
      return name.includes(searchTerm) || alternativeName.includes(searchTerm);
    });
  });
}

